import {Component, inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {selectIsLoading} from '@em/onboarding/data-access';

@Component({
  selector: 'em-onboarding-page',
  templateUrl: './onboarding-page.component.html',
  styleUrls: ['./onboarding-page.component.scss'],
  standalone: false,
})
export class OnboardingPageComponent {
  private readonly _store = inject(Store);

  readonly isLoading = this._store.select(selectIsLoading);
}
